import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcesosSicComponent } from './procesos-sic/procesos-sic.component';
import { ProcesosDimarComponent } from './procesos-dimar/procesos-dimar.component';
import { ProcesosDndaComponent } from './procesos-dnda/procesos-dnda.component';
import { UtilModule } from '../util/util.module';
import { CoreModule } from '../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProcesosSupersaludComponent } from './procesos-supersalud/procesos-supersalud.component';
import { ProcesosIcaComponent } from './procesos-ica/procesos-ica.component';
import { ProcesosSuperfinancieraComponent } from './procesos-superfinanciera/procesos-superfinanciera.component';
import { ProcesosSupersociedadesMercantilesComponent } from './procesos-supersociedades-mercantiles/procesos-supersociedades-mercantiles.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ResumenGeneralComponent } from './resumen-general/resumen-general.component';

@NgModule({
  declarations: [
    ProcesosSicComponent,
    ProcesosDimarComponent,
    ProcesosDndaComponent,
    ProcesosSupersaludComponent,
    ProcesosIcaComponent,
    ProcesosSuperfinancieraComponent,
    ProcesosSupersociedadesMercantilesComponent,
    ResumenGeneralComponent,
  ],
  imports: [
    CommonModule,
    UtilModule,
    CoreModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    TranslatePipe,
  ],
})
export class VisualizacionModule {}
